// LLM generated - Model Claude 4 Sonnet
type IconGiftAuroraProps = {
  size?: number;
  strokeWidth?: number;
};

export default function IconGiftAurora({ size = 40, strokeWidth = 3.25 }: IconGiftAuroraProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 13.3333V35M20 13.3333C19.3971 10.849 18.3591 8.72501 17.0212 7.23851C15.6834 5.752 14.1078 4.97189 12.5 4.9999C11.3949 4.9999 10.3351 5.43889 9.55372 6.22029C8.77232 7.00169 8.33333 8.0615 8.33333 9.16657C8.33333 10.2716 8.77232 11.3314 9.55372 12.1129C10.3351 12.8943 11.3949 13.3332 12.5 13.3332M20 13.3333C20.6029 10.849 21.6409 8.72501 22.9788 7.23851C24.3166 5.752 25.8922 4.97189 27.5 4.9999C28.6051 4.9999 29.6649 5.43889 30.4463 6.22029C31.2277 7.00169 31.6667 8.0615 31.6667 9.16657C31.6667 10.2716 31.2277 11.3314 30.4463 12.1129C29.6649 12.8943 28.6051 13.3332 27.5 13.3332M31.6667 20V31.6667C31.6667 32.5507 31.3155 33.3986 30.6904 34.0237C30.0652 34.6488 29.2174 35 28.3333 35H11.6667C10.7826 35 9.93477 34.6488 9.30964 34.0237C8.68452 33.3986 8.33333 32.5507 8.33333 31.6667V20M6.66667 13.3333H33.3333C34.2538 13.3333 35 14.0795 35 15V18.3333C35 19.2538 34.2538 20 33.3333 20H6.66667C5.74619 20 5 19.2538 5 18.3333V15C5 14.0795 5.74619 13.3333 6.66667 13.3333Z"
        stroke="url(#paint0_linear_gift_aurora)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_gift_aurora"
          x1="35"
          y1="19.9996"
          x2="5"
          y2="19.9996"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F1A93" />
          <stop offset="1" stopColor="#1BC4CF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

IconGiftAurora.displayName = 'IconGiftAurora';
